export default __webpack_public_path__ + "static/media/venus.f668d912.svg";